import { Team } from '@brg/api';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface OrganizationsState {
    team: any,
    teamId: string;
    tagIds: string[];
    contextName: string;
    managedTagIds: string[];
    avatar?: File[];
    ownersIDs?: string[]
}

const initialState = {
    team: null,
    teamId: '',
    tagIds: [],
    contextName: '',
    avatar: [],
    managedTagIds: [],
    ownersIDs: []
} as OrganizationsState


export const OrganizationsSlice = createSlice({
    name: 'Organizations',
    initialState,
    reducers: {
        setFullOrganization: (state, action) => {
            state.team = action.payload;
        },
        setOrganization: (state, action: PayloadAction<{teamId: string, tagIds: string[], contextName: string, avatar?: [], managedTagIds: string[], ownersIDs?: string[]}>) => {
            state.teamId = action.payload.teamId;
            state.tagIds = action.payload.tagIds;
            state.contextName = action.payload.contextName;
            state.avatar = action.payload.avatar;
            state.managedTagIds = action.payload.managedTagIds;
            state.ownersIDs = action.payload.ownersIDs
        },
        clearOrganization:  (state) => {
            state.teamId = '';
            state.tagIds = [];
            state.contextName = '';
            state.avatar = [];
            state.managedTagIds = [];
            state.ownersIDs = []        }
            ,
    },
});

export default OrganizationsSlice
export const OrganizationsActions = OrganizationsSlice.actions
export const OrganizationsSelector = (store: { organizations: OrganizationsState }): OrganizationsState => store.organizations;
import { Team } from '@brg/api';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface OrganizationsState {
    team: any,
    teamId: string;
    tagIds: string[];
    contextName: string;
    managedTagIds: string[];
    avatar?: File[];
    ownersIDs?: string[]
}

const initialState = {
    team: null,
    teamId: '',
    tagIds: [],
    contextName: '',
    avatar: [],
    managedTagIds: [],
    ownersIDs: []
} as OrganizationsState


export const OrganizationsSlice = createSlice({
    name: 'Organizations',
    initialState,
    reducers: {
        setFullOrganization: (state, action) => {
            state.team = action.payload;
        },
        setOrganization: (state, action: PayloadAction<{teamId: string, tagIds: string[], contextName: string, avatar?: [], managedTagIds: string[], ownersIDs?: string[]}>) => {
            state.teamId = action.payload.teamId;
            state.tagIds = action.payload.tagIds;
            state.contextName = action.payload.contextName;
            state.avatar = action.payload.avatar;
            state.managedTagIds = action.payload.managedTagIds;
            state.ownersIDs = action.payload.ownersIDs
        },
        clearOrganization:  (state) => {
            state.teamId = '';
            state.tagIds = [];
            state.contextName = '';
            state.avatar = [];
            state.managedTagIds = [];
            state.ownersIDs = []        }
            ,
    },
});

export default OrganizationsSlice
export const OrganizationsActions = OrganizationsSlice.actions
export const OrganizationsSelector = (store: { organizations: OrganizationsState }): OrganizationsState => store.organizations;
